var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h20v20H0z","key":0}),React.createElement("rect",{"x":"6","y":"3","width":"8","height":"14","rx":"1","stroke":"#fff","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M5 14h10v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2Z","fill":"#fff","key":2}),React.createElement("rect",{"x":"8","y":"15.5","width":"4","height":"1","rx":".5","key":3})]);
}

Mobile.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Mobile;

Mobile.default = Mobile;
